import React from 'react';
import BattleshipMonopolyBoard from '../components/BattleshipMonopolyBoard';
import BattleshipSpectatorPage from './BattleshipSpectatorPage';
import '../styles/BattleshipTV.css';

const BattleshipTVPage = () => {
  return (
    <div className="btv-container">
      <div className="btv-panel btv-monopoly">
        <BattleshipMonopolyBoard compact={true} />
      </div>
      <div className="btv-panel btv-battleship">
        <BattleshipSpectatorPage compact={true} />
      </div>
      <button
        className="btv-fullscreen-btn"
        onClick={() => document.documentElement.requestFullscreen?.()}
        title="Fullscreen"
      >&#x26F6;</button>
    </div>
  );
};

export default BattleshipTVPage;
